import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { Zap, TrendingUp, Battery } from 'lucide-react';
export function TokensPerWattSlide() {
  const benchmarks = [{
    name: 'Positron Atlas',
    hardware: 'Altera Agilex-7M FPGAs',
    stat: '70%',
    statLabel: 'more tokens/sec than Hopper',
    detail: '3.5× the performance per watt vs NVIDIA H100/H200',
    source: '[17]'
  }, {
    name: 'LoopLynx',
    hardware: 'Dual-FPGA Design',
    stat: '2.52×',
    statLabel: 'speed-up over A100',
    detail: 'While consuming only 48.1% of the energy',
    source: '[18][19]'
  }];
  return <SlideLayout slideNumber={9} totalSlides={20} title="Technical Deep Dive" data-id="element-532">
      <div className="w-full h-full flex flex-col" data-id="element-533">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-5" data-id="element-534">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-lg font-medium mb-3" data-id="element-535">
            <Zap size={20} data-id="element-536" />
            <span data-id="element-537">Performance Data</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-2" data-id="element-538">
            Better <span className="text-brand-primary" data-id="element-539">Tokens Per Watt</span>
          </h2>
          <p className="text-2xl text-brand-muted max-w-3xl mx-auto" data-id="element-540">
            FPGAs achieve{' '}
            <span className="text-white font-mono font-bold" data-id="element-541">5–20×</span> higher
            tokens-per-second per watt compared to H100/H200 GPUs.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 flex-1 mb-5" data-id="element-542">
          {benchmarks.map((bench, index) => <motion.div key={bench.name} initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.15 + 0.3
        }} className="bg-brand-surface border border-brand-primary/30 rounded-2xl p-8 relative overflow-hidden flex flex-col justify-center" data-id="element-543">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-primary to-brand-primary/30" data-id="element-544" />
              <div className="flex items-center gap-3 mb-2" data-id="element-545">
                <h3 className="text-2xl font-bold text-white" data-id="element-546">{bench.name}</h3>
                <span className="text-base font-mono text-brand-muted bg-brand-dark px-2 py-0.5 rounded" data-id="element-547">
                  {bench.source}
                </span>
              </div>
              <p className="text-lg text-brand-muted mb-5 font-mono" data-id="element-548">
                {bench.hardware}
              </p>
              <div className="mb-3" data-id="element-549">
                <span className="text-6xl md:text-7xl font-mono font-bold text-brand-primary" data-id="element-550">
                  {bench.stat}
                </span>
                <span className="text-2xl text-brand-muted ml-3" data-id="element-551">
                  {bench.statLabel}
                </span>
              </div>
              <p className="text-xl text-brand-muted" data-id="element-552">{bench.detail}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="flex justify-center gap-12" data-id="element-553">
          {[{
          icon: TrendingUp,
          label: '5–20× tokens/watt',
          desc: 'vs GPU baseline'
        }, {
          icon: Battery,
          label: '<50% energy',
          desc: 'at equivalent throughput'
        }, {
          icon: Zap,
          label: 'Real benchmarks',
          desc: 'not theoretical peaks'
        }].map(item => <div key={item.label} className="text-center" data-id="element-554">
              <div className="mx-auto mb-2 p-2 bg-brand-primary/10 w-fit rounded-lg text-brand-primary" data-id="element-555">
                <item.icon size={24} data-id="element-556" />
              </div>
              <div className="text-lg font-bold text-white" data-id="element-557">{item.label}</div>
              <div className="text-base text-brand-muted" data-id="element-558">{item.desc}</div>
            </div>)}
        </motion.div>
      </div>
    </SlideLayout>;
}